import { useBannerAnnouncement } from '@notification/announcement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const BannerAnnouncement: React.FC<unknown> = () => {
  const [bannerAnnouncement, setMarkAsReadBannerAnnouncement] = useBannerAnnouncement();

  if (!bannerAnnouncement) {
    return null;
  }

  return (
    <div className="mb-auto ml-auto flex justify-end">
      <div className="pointer-events-auto flex rounded-lg bg-red-400 px-4 py-2" data-testid="banner-announcement">
        <div>
          <a href={bannerAnnouncement.url} target="_blank" rel="noreferrer" className="hover:underline">
            {bannerAnnouncement.title}
          </a>
        </div>
        <div className="ml-2 cursor-pointer" onClick={setMarkAsReadBannerAnnouncement}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    </div>
  );
};
